<template>
  <div>
    <h1 class="main-header" v-translate translate-context="form'">Create</h1>
    <TagForm :data="empty" @save="onSave" :save_text="$pgettext('form','Create')"/>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {SuccessNotification} from "@/domain/core/exception/exceptions";
import TagForm from "@/domain/tag/components/TagForm.vue";

export default {
  name: 'NewTag',
  components: {TagForm},
  data() {
    return {
      empty: {
        code: '',
        description: '',
      }
    }
  },
  methods: {
    ...mapActions('tag', [
      'createTag',
    ]),
    async onSave(data) {
      await this.createTag({
        ...data,
        category: this.$route.params.category
      })
      await this.$router.push({name: 'tag.list', category: this.$route.params.category})
      throw new SuccessNotification(this.$pgettext('tag', 'Tag created!'))
    }
  }
}
</script>

<style scoped>

</style>